var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2075 4.58563L11.4144 1.79313C11.3215 1.70024 11.2113 1.62656 11.0899 1.57629C10.9686 1.52603 10.8385 1.50015 10.7072 1.50015C10.5759 1.50015 10.4458 1.52603 10.3245 1.57629C10.2031 1.62656 10.0929 1.70024 10 1.79313L2.29313 9.5C2.19987 9.59252 2.12593 9.70266 2.0756 9.82401C2.02528 9.94536 1.99959 10.0755 2.00001 10.2069V13C2.00001 13.2652 2.10536 13.5196 2.2929 13.7071C2.48043 13.8946 2.73479 14 3.00001 14H13.5C13.6326 14 13.7598 13.9473 13.8536 13.8536C13.9473 13.7598 14 13.6326 14 13.5C14 13.3674 13.9473 13.2402 13.8536 13.1464C13.7598 13.0527 13.6326 13 13.5 13H7.20751L14.2075 6C14.3004 5.90714 14.3741 5.79689 14.4243 5.67555C14.4746 5.55421 14.5005 5.42415 14.5005 5.29281C14.5005 5.16147 14.4746 5.03142 14.4243 4.91008C14.3741 4.78874 14.3004 4.67849 14.2075 4.58563ZM5.79313 13H3.00001V10.2069L8.50001 4.70688L11.2931 7.5L5.79313 13ZM12 6.79313L9.20751 4L10.7075 2.5L13.5 5.29313L12 6.79313Z",
    fill: "#1C1D21",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.ee68132e7953eca018ab2f67266e65df.svg";
export { ForwardRef as ReactComponent };